import { CompanyLifecycle } from 'generated/graphql';
import { TSelectOption } from '@spotted-zebra-uk/ui-components';

// Readable labels for each lifecycle value. Single source of truth for both the
// edit-mode dropdown options and the view-mode label. Defined explicitly (rather
// than auto-formatting the enum) so acronyms like "POC" keep their casing.
export const COMPANY_LIFECYCLE_LABELS: Record<CompanyLifecycle, string> = {
  [CompanyLifecycle.Internal]: 'Internal',
  [CompanyLifecycle.Demo]: 'Demo',
  [CompanyLifecycle.Poc]: 'POC',
  [CompanyLifecycle.Live]: 'Live',
  [CompanyLifecycle.Churned]: 'Churned',
};

// Ordered in logical lifecycle sequence (not alphabetically) for the dropdown.
const COMPANY_LIFECYCLE_ORDER: CompanyLifecycle[] = [
  CompanyLifecycle.Internal,
  CompanyLifecycle.Demo,
  CompanyLifecycle.Poc,
  CompanyLifecycle.Live,
  CompanyLifecycle.Churned,
];

export const companyLifecycleOptions: TSelectOption<CompanyLifecycle>[] =
  COMPANY_LIFECYCLE_ORDER.map(value => ({
    value,
    label: COMPANY_LIFECYCLE_LABELS[value],
  }));
